import React from 'react';
import NumberFormat from 'react-number-format';
import { Field } from 'formik';

const PhoneNumber = ({ name, placeholder, showErrorMessages = true, disabled }) => (
  <Field name={name}>
    {({ field, meta }) => (
      <div className="app-input-text">
        <NumberFormat
          format="(###) ###-####"
          name={field.name}
          placeholder={placeholder}
          className={`${meta.touched && meta.error ? 'error' : ''}`}
          disabled={disabled}
          {...field}
        />
        {meta.touched && meta.error && showErrorMessages && (
          <p name={name + 'Error'} className="error-message">{meta.error}</p>
        )}
      </div>
    )}
  </Field>
);

export default PhoneNumber;
